import * as React from "react";
import cx from "classnames";
import SectionTitle from "../Layout/Section/Title";
import Container from "../Layout/Container";
import TemplateString from "../Common/TemplateString";
import Button from "../UI/Button";
import CheckMarkerIcon from "../../assets/svg/check_marker_cc.svg";
import * as styles from "./favorablecards.module.css";

const TariffFavorableCards = ({leftCard, rightCard}) => {
    if (!leftCard || !rightCard) {
        return null;
    }

    return (
        <Container className={styles.favorablecards__container}>
            <SectionTitle>Выберите выгодный тариф</SectionTitle>
            <div className={styles.favorablecards__cards}>
                <div className={styles.favorablecards__card}>
                    <p className={styles.favorablecards__cardKicker}>{leftCard.kicker}</p>
                    <h3 className={styles.favorablecards__cardTitle}>{leftCard.title}</h3>
                    <p className={styles.favorablecards__cardDescription}>
                        <TemplateString template={leftCard.description} />
                    </p>
                    <ul className={styles.favorablecards__cardList}>
                        {leftCard.list.map(({id, text}) => {
                            return (
                                <li key={id} className={styles.favorablecards__cardListItem}>
                                    <CheckMarkerIcon />
                                    {text}
                                </li>
                            );
                        })}
                    </ul>
                    <div className={styles.favorablecards__cardButtons}>
                        <Button
                            href="./#compare"
                            isLink
                            external={false}
                            className={cx(styles.favorablecards__cardButton, styles.favorablecards__cardButton_border)}
                        >
                            Узнать подробнее
                        </Button>
                        <Button
                            href="./#calculator"
                            isLink
                            variant="primary"
                            external={false}
                            className={cx(styles.favorablecards__cardButton, styles.favorablecards__cardButton_filled)}
                        >
                            Рассчитать стоимость
                        </Button>
                    </div>
                </div>
                <div className={styles.favorablecards__card}>
                    <p className={styles.favorablecards__cardKicker}>{rightCard.kicker}</p>
                    <h3 className={styles.favorablecards__cardTitle}>{rightCard.title}</h3>
                    <p className={styles.favorablecards__cardDescription}>
                        <TemplateString template={rightCard.description} />
                    </p>
                    <ul className={styles.favorablecards__cardList}>
                        {rightCard.list.map(({id, text}) => {
                            return (
                                <li key={id} className={styles.favorablecards__cardListItem}>
                                    <CheckMarkerIcon /> {text}
                                </li>
                            );
                        })}
                    </ul>
                    <div className={styles.favorablecards__cardButtons}>
                        {rightCard.firstButtonLink && (
                            <Button
                                href={rightCard.firstButtonLink}
                                isLink
                                className={cx(
                                    styles.favorablecards__cardButton,
                                    styles.favorablecards__cardButton_border,
                                )}
                            >
                                Узнать подробнее
                            </Button>
                        )}
                        {rightCard.secondButtonLink && (
                            <Button
                                href={rightCard.secondButtonLink}
                                isLink
                                variant="primary"
                                className={cx(
                                    styles.favorablecards__cardButton,
                                    styles.favorablecards__cardButton_filled,
                                )}
                            >
                                Рассчитать стоимость
                            </Button>
                        )}
                    </div>
                </div>
            </div>
        </Container>
    );
};

export default TariffFavorableCards;
